import { useEffect, useState } from "react";
import DrawerLateral from "./DrawerLateral";
import Button from "../../../componentes/button/button";
import Textarea from "../../../componentes/input/textarea";
import { CustomDropdown } from "../../../componentes/dropdown/CustomDropdown";
import UsuarioService from "../../../services/resource/usuarioService";
import { useAuth } from "../../../context/authContext";
import { etapaLabel } from "../../../utils/solicitacoes/processoRegistry";
import { humanizarEtapa } from "../../../utils/solicitacoes/statusConfig";

const usuarioService = new UsuarioService();

// Quem está com a tarefa (responsável atual, ou admin) pode transferi-la para qualquer outro
// usuário ativo do sistema — ao contrário de AlterarResponsavelSidebar.jsx (admin-only, restrito
// aos membros do grupo da etapa), aqui a lista vem de todos os usuários cadastrados.
export default function TransferirTarefaSidebar({ isOpen, solicitacao, onFechar, onConfirmar }) {
    const { user } = useAuth();
    const [usuarios, setUsuarios] = useState([]);
    const [carregandoUsuarios, setCarregandoUsuarios] = useState(false);
    const [novoUsuarioId, setNovoUsuarioId] = useState(null);
    const [motivo, setMotivo] = useState("");
    const [salvando, setSalvando] = useState(false);

    useEffect(() => {
        if (!isOpen || !solicitacao) return;
        setNovoUsuarioId(null);
        setMotivo("");
        setCarregandoUsuarios(true);
        usuarioService.listarUsuariosMydashSolicitacao()
            .then(res => setUsuarios(
                (res.data || []).filter(u => u.ativo && u.id !== user?.id)
            ))
            .catch(() => setUsuarios([]))
            .finally(() => setCarregandoUsuarios(false));
    }, [isOpen, solicitacao, user]);

    if (!solicitacao) return null;

    const etapaTxt = solicitacao.etapaAtual
        ? (etapaLabel(solicitacao.tipoProcesso, solicitacao.etapaAtual) || humanizarEtapa(solicitacao.etapaAtual))
        : "Encerrada";
    const semUsuarios = !carregandoUsuarios && usuarios.length === 0;
    const podeConfirmar = !salvando && !!novoUsuarioId && !semUsuarios;

    function confirmar() {
        setSalvando(true);
        onConfirmar(novoUsuarioId, motivo.trim() || null)
            .catch(() => {})
            .finally(() => setSalvando(false));
    }

    return (
        <DrawerLateral
            isOpen={isOpen}
            onClose={onFechar}
            title="Transferir tarefa"
            footer={
                <div className="flex justify-end gap-2">
                    <Button variant="outline" label="Cancelar" onClick={onFechar} disabled={salvando} />
                    <Button
                        variant="blue"
                        label="Transferir"
                        iconLeft="fa fa-share"
                        loading={salvando}
                        disabled={!podeConfirmar}
                        onClick={confirmar}
                    />
                </div>
            }
        >
            <div className="grid grid-cols-2 gap-3 text-sm">
                <Campo label="Solicitação" valor={solicitacao.numero} />
                <Campo label="Etapa" valor={etapaTxt} />
            </div>

            <div className="flex flex-col gap-1.5">
                <label className="text-sm font-medium text-foreground/80">
                    Transferir para <span className="text-destructive">*</span>
                </label>
                <CustomDropdown
                    value={novoUsuarioId}
                    onChange={e => setNovoUsuarioId(e.value)}
                    options={usuarios}
                    optionValue="id"
                    optionLabel="nome"
                    placeholder={carregandoUsuarios ? "Carregando..." : "Selecione um usuário"}
                    disabled={carregandoUsuarios || semUsuarios}
                    filter
                />
                {semUsuarios && (
                    <span className="text-xs text-destructive">
                        Nenhum outro usuário disponível para receber a tarefa.
                    </span>
                )}
            </div>

            <div className="flex flex-col gap-1.5">
                <label className="text-sm font-medium text-foreground/80">Motivo (opcional)</label>
                <Textarea
                    id="motivo-transferir-tarefa"
                    placeholder="Informe o motivo da transferência..."
                    value={motivo}
                    onChange={e => setMotivo(e.target.value)}
                    rows={3}
                />
            </div>
        </DrawerLateral>
    );
}

function Campo({ label, valor }) {
    return (
        <div className="min-w-0">
            <span className="block text-[11px] uppercase tracking-wide text-muted-foreground font-semibold">{label}</span>
            <span className="block text-foreground font-medium truncate" title={valor || "-"}>{valor || "-"}</span>
        </div>
    );
}
